﻿(function($) {
    //If using the US site we need to move to the newer version of this.
    var currentpath = document.location.pathname.split(/[/"]/);
    var origin = document.location.origin.includes("com.au");
    window.veCurrentLocale = currentpath.length > 3 ? currentpath[1] + currentpath[2] : currentpath[1];
    if (!origin) {
        $.getScript("/static/us/js/dist/generic-promo-banner-only.js")
        return;
    }

  var markupsToDisplay = {
    moreTemplate: null,
    lessTemplate: null,
    markups: new Array()
  };
  var notifies = new Array();
  var isMore = false;
  var isExpanded = false;
  var banners = null;

  function getCookie(name) {
    var value = "; " + decodeURIComponent(document.cookie);
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  function log(value) {
    var cookieValue = getCookie("test-ve-cdn");
    if (cookieValue === "{e}DrUl13/3LLX8AQepD5LOpg==") {
      console.log(value);
    }
  }

  function showNotificationBanners() {
    $.ajax({
      type: 'GET',
      url: '/banners/get',
      success: function(items) {
        log('Get notification banners:');
        log(items);
        banners = items;
        getNotificationBannersIdsToDisplayAndShow(items);
      }
    });
  }

  function getNotificationBannersIdsToDisplayAndShow(notificationBanners) {
    var bannerInfoForFiltering = new Array();

    for (var i = 0; i < notificationBanners.length; i++) {
      var banner = notificationBanners[i];
      bannerInfoForFiltering.push({
        Id: banner.Id,
        StartDateTimeUtc: banner.StartDateTimeUtc,
        EndDateTimeUtc: banner.EndDateTimeUtc,
        BannerType: banner.BannerType
      });
    }

    if (bannerInfoForFiltering.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/banners/display',
        data: {
          timeZoneOffset: new Date().getTimezoneOffset(),
          bannerInfoForFiltering: bannerInfoForFiltering
        },
        success: function(idsToDisplay) {
          log('Display banners:' + idsToDisplay);
          markupsToDisplay.markups = new Array();
          notificationBanners.forEach(function(item) {
            if (idsToDisplay.indexOf(item.Id) !== -1) {
              markupsToDisplay.moreTemplate = item.MarkupMore;
              markupsToDisplay.lessTemplate = item.MarkupLess;
              markupsToDisplay.markups.push(item.Markup);
            }
          });
          isMore = markupsToDisplay.markups.length > 0;
          showAllOrOneBanner();
          setBannersMoreLessButton();
        }
      });
    }
  }

  function showBanner(isMoreClicked) {
    if (markupsToDisplay.markups.length === 0) {
      return;
    }

    if (!isMoreClicked) {
      showBannerInternal(0);
    } else {
      showAllBanners(false);
      $('body').on('click',
        '.js-less-button',
        function() {
          isExpanded = false;
          showLessNotifies();
          setBannersMoreLessButton();
        });
    }
  }

  function showAllBanners(showFirst) {
    for (var i = 0; i < markupsToDisplay.markups.length; i++) {
      if (i !== 0 || showFirst) {
        showBannerInternal(i);
      }
    }
  }

  function closeAllNotifies() {
    for (var i = notifies.length - 1; i >= 0; i--) {
      notifies[i].close();
    }

    notifies = new Array();
  }

  function showLessNotifies() {
    for (var i = notifies.length - 1; i >= 0; i--) {
      if (i !== 0) {
        notifies[i].close();
        notifies.splice(i, 1);
      }
    }

    $(".banner-notification").css("bottom", "0px");
  }

  function showAllOrOneBanner() {
    if (!isExpanded) {
      showBanner(false);
    } else {
      showAllBanners(true);
    }
  }

  function setBannersMoreLessButton() {
    setButtonVisual(".js-more-button", !isExpanded);
    setButtonVisual(".js-less-button", isExpanded);
  }

  function showBannerInternal(bannerIndex) {
    var markupLess = markupsToDisplay.lessTemplate;
    var markupMore = markupsToDisplay.moreTemplate;
    var markup = markupsToDisplay.markups[bannerIndex];

    var isLast = bannerIndex === markupsToDisplay.markups.length - 1;
    var isFirst = bannerIndex === 0;

    if (markupsToDisplay.markups.length === 1) {
      markup = markup.replace("{MoreLessButton}", "");
    } else {
      if (isFirst) {
        markup = markup.replace("{MoreLessButton}", markupMore);
      } else if (isLast) {
        markup = markup.replace("{MoreLessButton}", markupLess);
      } else {
        markup = markup.replace("{MoreLessButton}", "");
      }
    }

    var notify = $.notify({},
      {
        element: 'body',
        position: null,
        type: "info",
        allow_dismiss: true,
        newest_on_top: true,
        showProgressbar: false,
        placement: {
          from: "bottom",
          align: "center"
        },
        offset: 0,
        spacing: 0,
        z_index: 1031,
        delay: 0,
        timer: 1000,
        url_target: '_blank',
        animate: {
          enter: "animated fadeInUp",
          exit: "animated fadeOutDown"
        },
        icon_type: 'class',
        template: markup
      });
    notifies.push(notify);
  }

  function setButtonVisual(buttonClass, isShow) {
    var moreButtons = $(buttonClass);
    if (isShow) {
      moreButtons.css('visibility', 'visible');
    } else {
      moreButtons.css('visibility', 'hidden');
    }
  }

  function updateBannerState(id, state, goToUrl) {
    $.ajax({
      type: 'POST',
      url: '/banners/set',
      data: {
        id: id,
        state: state
      },
      success: function() {

        log('Set cookie: ' + state);

        if (goToUrl) {
          location.href = goToUrl;
        }

        closeAllNotifies();
        getNotificationBannersIdsToDisplayAndShow(banners);
      }
    });
  }

  function registerHandler() {
    var button = $(this),
      bannerContainer = button.closest('[data-item-id]'),
      webinarId = bannerContainer.attr('data-item-id'),
      state = 'Registered',
      registerPageUrl = button.attr('data-href');

    updateBannerState(webinarId, state, registerPageUrl);
  }

  function noThanksHandler() {
    var button = $(this),
      bannerContainer = button.closest('[data-item-id]'),
      webinarId = bannerContainer.attr('data-item-id'),
      state = 'Closed';

    updateBannerState(webinarId, state);
  }

  $(function() {
    var isAdmin = window.location.href.toLocaleLowerCase().indexOf("admin") > -1;

    if (!isAdmin) {
      showNotificationBanners();
      
      $('body').on('click', '.js-register-now', registerHandler);
      $('body').on('click', '.js-no-thanks', noThanksHandler);

      $('body').on('click',
        '.js-more-button',
        function() {
          isExpanded = true;
          showBanner(true);
          setBannersMoreLessButton();
        });
    }
  });
})(jQuery);
